import React from "react";
import WhyCosmicCareness from "./WhyCosmicCareness";

// 🔹 Images
import img1 from "../../Assets/7th_slider/2032-lw.png";
import img2 from "../../Assets/7th_slider/2481-wq.png";
import img3 from "../../Assets/7th_slider/4315-gg.png";
import img4 from "../../Assets/7th_slider/4316-jc.png";
import img5 from "../../Assets/7th_slider/4318-dc.png";
import img6 from "../../Assets/7th_slider/4319-dr.png";

const images = [img2, img1, img6, img5, img4, img3];

const ExclusiveStore = () => {
  return (
    <>
      <div className="w-full bg-white py-10">
        <div className="max-w-7xl mx-auto px-4">

          {/* 🔹 TITLE */}
          <h2 className="text-[30px] font-medium text-black mb-6">
            Exclusive Store
          </h2>

          {/* 🔹 IMAGE ROW */}
          <div
            className="
              flex
              gap-4
              overflow-x-auto
              no-scrollbar
              sm:justify-between
            "
          >
            {images.map((img, index) => (
              <div
                key={index}
                className="
                  flex-shrink-0
                  w-[154px]
                  h-[240px]
                  rounded-xl
                  bg-white
                  overflow-hidden
                "
              >
                <img
                  src={img}
                  alt={`exclusive-${index}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* <WhyCosmicCareness /> */}
    </>
  );
};

export default ExclusiveStore;
